<template>
  <div>
    <v-app class="no-background-color" style="background-color: #F5F5F5;">
      <epsHeader :drawer="$store.state.drawer" />

      <v-main>
        <v-container fluid>
          <v-row>
            <!-- Main View Column -->
            <v-col
              :cols="$vuetify.breakpoint.xs ? 12 : $vuetify.breakpoint.md ? 12 : $vuetify.breakpoint.lg ? (isDrawer && $route.path === '/home' ? 9 : 12) : 12"
              v-if="user_type === 'Employee' && IsSwitched=='true' && IsAdminRole=='true'">
              <Admin-Landing-Page-Component class="mt-12 shift-content" 
                v-if="($route.path === '/home')  && isDrawer" />
              <router-view ref="rv" class="mt-12" />
            </v-col>
            <v-col v-else-if="user_type === 'Employee' && !(IsSwitched === true && IsAdminRole === true)"
              :cols="$vuetify.breakpoint.xs ? 12 : $vuetify.breakpoint.md ? 12 : $vuetify.breakpoint.lg ? (isDrawer && $route.path === '/home' ? 9 : 12) : 12">
              <FacultyDashboardLanding class="mt-12 shift-content"
                v-if="$route.path === '/home' && isDrawer" />
              <router-view ref="rv" class="mt-12" />
            </v-col>
            <v-col v-else
              :cols="$vuetify.breakpoint.xs ? 12 : $vuetify.breakpoint.md ? 12 : $vuetify.breakpoint.lg ? (isDrawer && $route.path === '/home' ? 9 : 12) : 6">
              <parent-profile-card class="mt-12 shift-content" @childEvent="handleChildEvent"
                v-if="($route.path === '/home') && (user_type === 'Parent' || user_type === 'Student') && isDrawer" />
              <router-view ref="rv" style="margin-top: 60px;" />
            </v-col>
            <!-- Right Section: Only visible on /home if drawer is true -->
            <v-col v-if="isDrawer && $route.path === '/home' && user_type === 'Employee'"
              :cols="$vuetify.breakpoint.xs ? 12 : $vuetify.breakpoint.md ? 6 : $vuetify.breakpoint.lg ? 3 : 6">
              <updated-employee-right-section class="mt-7" />

            </v-col>
            <v-col v-else
              :cols="$vuetify.breakpoint.xs ? 12 : $vuetify.breakpoint.md ? 6 : $vuetify.breakpoint.lg ? 3 : 6">
              <parent-upcoming-events :key="render" :l_id="l_id" :ay_id="ay_id" class="mt-4"
                v-if="isDrawer && $route.path === '/home'" />
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>

<script>
  import UpdatedEmployeeRightSection from "@/components/shared/UpdatedEmployeeRightSection.vue";
  import AdminLandingPageComponent from "@/components/AdminDashboard/AdminDashboardLanding.vue";
  import ParentProfileCard from "@/components/shared/ParentProfileCard.vue";
  import parentUpcomingEvents from "@/components/shared/ParentUpcomingEvents.vue";
  import FacultyDashboardLanding from "@/components/FacultyDashboard/FacultyDashboardLanding.vue";
  import epsHeader from "../shared/UpdatedHeader";

  export default {
    components: {
      parentUpcomingEvents,
      ParentProfileCard,
      UpdatedEmployeeRightSection,
      AdminLandingPageComponent,
      epsHeader,
      FacultyDashboardLanding,
    },
    data() {
      return {
        isDrawer: true,
        drawerInterval: null,
        user_type: null,
        render: 0,
        l_id: "",
        ay_id: "",
        IsSwitched: sessionStorage.getItem('IsSwitched') === 'true',
        IsAdminRole: false,
      };
    },
    methods: {
      syncDrawerState() {
        const storedValue = sessionStorage.getItem("isDrawer");
        const parsed = storedValue === null ? true : storedValue === "true";
        if (this.isDrawer !== parsed) {
          console.log("Drawer updated from sessionStorage:", parsed);
          this.isDrawer = parsed;
        }
      },
      handleChildEvent(data) {
        this.l_id = data.learner;
        this.ay_id = data.ay;
        this.render++;
      },
    },
    mounted() {
      this.IsSwitched = this.$route.query.IsSwitched;
      this.IsAdminRole = this.$route.query.IsAdminRole;
      if (this.$route.path === "/home") {
        sessionStorage.removeItem("emp_role_dashboard_path");
        sessionStorage.removeItem("is_quick_link");
        sessionStorage.removeItem("para_role_type");
        sessionStorage.removeItem("para_role")
        sessionStorage.removeItem("is_from_search")
        // sessionStorage.removeItem("master_module_name");
      }
      this.user_type = localStorage.getItem("EPS-ut");
      if (sessionStorage.getItem("isDrawer") === null) {
        sessionStorage.setItem("isDrawer", this.$vuetify.breakpoint.xs ? "false" : "true");
      }
      this.syncDrawerState();
      this.drawerInterval = setInterval(this.syncDrawerState, 500);
      window.addEventListener("storage", this.syncDrawerState);
      console.log("Component mounted on route:", this.$route.path);
    },
    beforeDestroy() {
      clearInterval(this.drawerInterval);
      window.removeEventListener("storage", this.syncDrawerState);
    },
  };
</script>

<style scoped>
@media print {
  .no-background-color {
    background-color: white !important;
  } 
}
  @media (max-width: 600px) {
    .mt-4 {
      margin-top: 1rem !important;
    }
  }
  .shift-content {
    margin-left: 80px;
    transition: margin-left 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }

  
  ::v-deep .v-application:has(.v-navigation-drawer:hover) .shift-content {
    margin-left: 250px !important;
  }

  @media (max-width: 600px) {
    .mt-4 {
      margin-top: 1rem !important;
    }
    
   
    .shift-content {
      margin-left: 0px !important;
    }
  }
</style>